import chart from './chart'

export default {
  type: 'polar',

  mixins: [chart]
}
